import { curry, isNil, omitBy } from 'lodash'

import {
  Boolean_Comparison_Exp,
  Int_Comparison_Exp,
  Order_By,
  String_Comparison_Exp,
} from '@/types/cate-graphql-generated-types'
import { SortDirection } from '@/types/graphql-generated-types'

export const mapIntRangeFilter = (filter: { from?: number; to?: number }): Int_Comparison_Exp | null =>
  isNil(filter?.from) && isNil(filter?.to)
    ? null
    : omitBy(
        {
          _gte: filter?.from,
          _lte: filter?.to,
        },
        isNil
      )

export const mapBooleanFilter = (filter: boolean): Boolean_Comparison_Exp | null =>
  isNil(filter) || !filter
    ? null
    : {
        _eq: filter,
      }

export const mapBooleanFilterToIntComparison = (filter: boolean): Int_Comparison_Exp | null =>
  isNil(filter)
    ? null
    : {
        _gte: filter ? 1 : 0,
      }

export const mapArrayFilter = (filter: string[]): String_Comparison_Exp | null =>
  isNil(filter) || filter.length === 0 ? null : { _in: filter?.map((x) => x.toLowerCase()) }

export const mapComparisonExp = curry(<T extends unknown>(key: string, filter: T): Record<string, T> | null =>
  isNil(filter) || (Array.isArray(filter) && filter.length === 0) || (typeof filter === 'string' && filter.length === 0)
    ? null
    : {
        [key]: filter,
      }
)

export const mapSortDirection = (direction: SortDirection): Order_By =>
  direction === SortDirection.Asc ? Order_By.AscNullsLast : Order_By.DescNullsLast

export const mapCounter = mapComparisonExp('counter')
